import { isTestEnv } from "@zfp-akademie-a-s/zfp-design";
import { ADMIN_URL_DEFAULT, ZFP_API_URL_DEFAULT } from "./constants.ts";
import type { AnalyzerWindow, Config } from "./types";
declare const window: AnalyzerWindow;

const UNDEFINED = "UNDEFINED";

const config: Config = {
  zfpApiUrl: null,
  adminUrl: null,
  ssoClientId: null,
  hostUrl: `${window.location.protocol}//${window.location.host}`,
  env: null,
  branchName: null,
  commitMessage: null,
};

export const Configuration = {
  initConfig() {
    if (window?.config) {
      config.zfpApiUrl = window.config.zfpApiUrl ?? ZFP_API_URL_DEFAULT;
      config.adminUrl = window.config.adminUrl ?? ADMIN_URL_DEFAULT;
      config.env = window.config.env ?? null;
      config.branchName = window.config.branchName ?? null;
      config.commitMessage = window.config.commitMessage ?? null;
    } else {
      config.zfpApiUrl = ZFP_API_URL_DEFAULT;
      config.adminUrl = ADMIN_URL_DEFAULT;
    }
  },

  getApiUrlZfp() {
    return config.zfpApiUrl ?? ZFP_API_URL_DEFAULT;
  },

  getAdminUrl() {
    return config.adminUrl ?? ADMIN_URL_DEFAULT;
  },

  getHostUrl() {
    return config.hostUrl;
  },

  getIsProduction() {
    return config.env === "production";
  },

  getIsLocalhost() {
    return window.location.hostname === "localhost";
  },

  // getIsDevelopment gates the dev tools and test shortcuts; getIsTestEnv the test strip. Both are
  // on in the same environments (DEV and Staging in any case, and localhost)
  getIsDevelopment() {
    return this.getIsTestEnv();
  },

  getIsTestEnv() {
    return isTestEnv(config.env, window.location.hostname);
  },

  getEnvName() {
    return this.getIsLocalhost() ? "localhost" : config.env;
  },

  getBranchName() {
    return config.branchName ?? UNDEFINED;
  },

  getCommitMessage() {
    return config.commitMessage ?? UNDEFINED;
  },
};
